import { ccApi } from './ccApi';
import { CC_API_TAGS } from './constants';
// ---------------------------------------------------------------------------
// Endpoints
// ---------------------------------------------------------------------------
/**
 * RTK Query endpoints for Adhoc Messages (system notifications).
 *
 * Endpoints:
 * - `listAdhocMessages` – GET `/system-notifications/{clientId}` → list of adhoc messages
 *
 * Auth and tenant headers are handled by the base `ccApi`.
 */
export const adhocMessageApi = ccApi.injectEndpoints({
    endpoints: (builder) => ({
        listAdhocMessages: builder.query({
            query: ({ clientId }) => ({
                url: `/system-notifications/${clientId}`,
                method: 'GET',
            }),
            transformResponse: (response) => response.messages,
            providesTags: [CC_API_TAGS.AdhocMessage],
        }),
    }),
});
export const { useListAdhocMessagesQuery } = adhocMessageApi;
